export default {
  signature: ['required'],
};



// WEBPACK FOOTER //
// ./src/containers/pages/CertificateSettlement/schema.js